import axios from "axios";

var init = function () {
  document.getElementsByName("initSupportForm").forEach((supportForm) => {
    supportForm.addEventListener("submit", submitHandlerActive);
  });

  function submitHandlerActive(e) {
    e.preventDefault();
    const supportForm = e.currentTarget;
    supportForm.removeEventListener("submit", submitHandlerActive);
    supportForm.addEventListener("submit", submitHandlerPassive);
    axios
      .post(
        "/support/issue/init",
        Object.fromEntries(new FormData(supportForm)),
      )
      .then(function (response) {
        supportForm.innerHTML = response.data.formHtml;
        supportForm.removeEventListener("submit", submitHandlerPassive);
        supportForm.addEventListener("submit", submitHandlerActive);
      })
      .catch(function (error) {
        console.error(error);
        supportForm.removeEventListener("submit", submitHandlerPassive);
        supportForm.addEventListener("submit", submitHandlerActive);
      });
  }
  function submitHandlerPassive(e) {
    e.preventDefault();
  }
};
window.addEventListener("load", init, false);
